<template>
	<div class="ma-0 pa-0 menu-table-root pb-1">
		<v-data-table
		:headers="headers"		
		fixed-header
		:items="visibleModuleFunctions"		   
		class="elevation-1 module-function-table"
		disable-pagination
		hide-default-footer
		height="100%"
		width="100%"				
		item-key="id"
		v-model="selectedModuleFunction"
		>
			<template v-slot:item.moduleFuncCode="{ item }">
				<v-container  class="pt-4">
				<v-row>
					<v-col class="px-0">
						<template v-for="n in item.level-1" ><span :key="n"/>&#12288;</template>
					</v-col>
					<v-col class="mr-0">
						<v-icon v-if="canOpen(item)" v-on:click="openModuleFunction(item)">mdi-plus-box-outline</v-icon>
						<v-icon v-else-if="canClose(item)"  v-on:click="closeModuleFunction(item)">mdi-minus-box-outline</v-icon>
						<v-icon v-else>mdi-border-none-variant</v-icon>
					</v-col>
					<v-col class="pl-0 pr-1 mx-0">
						<v-icon v-if="item.selectState==1" v-on:click.stop.prevent="doUnSelectModuleFunction(item)">mdi-checkbox-marked</v-icon>
						<v-icon v-else-if="item.selectState==-1" v-on:click.stop.prevent="doSelectModuleFunction(item)">mdi-checkbox-blank-outline</v-icon>
						<v-icon v-else v-on:click.stop.prevent="doSelectModuleFunction(item)">mdi-checkbox-intermediate</v-icon>						
					</v-col >
					<v-col class="px-0 code-item">
						{{ item.moduleFuncCode}}
					</v-col>					
				</v-row>
				</v-container>
			</template>
		</v-data-table>
	</div>
</template>

<script>

	import {default as ModuleApi} from "../../../../api/smp/sys/ModuleApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	
	export default {
		name: 'ModuleFunctionSelectTable',
		components: {
		},
		data: () => ({
			headers: [
			
				{
					text: '代码',
					value: 'moduleFuncCode',
					sortable: false,
					width: 400,
					divider: true
				},
				{
					text: '编号',
					align: 'start',
					sortable: false,
					value: 'moduleFuncId',
					width: 80,
					divider: true
				},
				{
					text: '名称',
					value: 'moduleFuncName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '类型',
					value: 'typeName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '方法',
					value: 'methodName',
					sortable: false,
					width: 100,
					divider: true
				},
				{
					text: '路径',
					value: 'path',
					sortable: false,
					width: 300,
					divider: true
				}
			
			],
			modules: [],
			moduleFunctions: [],
			visibleModuleFunctions: [],
			selectedModule: null,
			selectedModuleFunction: [],
			moduleFunctionCodeMap: new Map(),
			moduleFunctionIdMap: new Map(),
			
			editing:true
		}),
		methods:{
			async errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			getSelectedModuleFunctions(){
				let me = this;
				let selected = [];
				this.moduleFunctions.forEach(function(item){
					me.collectSelected(selected,item);
				});
				return selected;
			},
			collectSelected(selected,moduleFunction){
				let me = this;
				if(moduleFunction.selectState==1)
					selected.push(moduleFunction);
				if(moduleFunction.lower){
					moduleFunction.lower.forEach(function(item){
						me.collectSelected(selected,item);
					});
				}
			},
			clear(){
				this.moduleFunctions=[];
				this.selectedModuleFunction=[];
				this.visibleModuleFunctions=[];
				this.moduleFunctionCodeMap.clear();
				this.moduleFunctionIdMap.clear();
			},
			setEditing(editing){
				this.editing = editing;
			},
			async loadModuleFunctions(moduleId){
				let me = this;
				if(!moduleId)
					return;
				let resp = await ModuleFunctionApi.queryByModuleId(moduleId);

				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取模块功能信息失败':msg;
					throw new Error(msg);
					return;
				}
				let moduleFunctions = data.data.moduleFunctions;	
				moduleFunctions = me.genTree(moduleFunctions);		
				me.customModuleFunctions(moduleFunctions);
				
				me.levelModuleFunctions(moduleFunctions,1,null);													
				me.moduleFunctions = moduleFunctions;
				me.collectVisibleModuleFunctions();
				
			},
			async loadSelected(selected){
				let me = this;
				let moduleFunctions = selected;	
				
				moduleFunctions.forEach(function(item){
					let moduleFunction = me.moduleFunctionCodeMap.get(item.code);
					if(moduleFunction)
						me.selectModuleFunctionState(moduleFunction,1,false,true);
				});

			},
			customModuleFunctions(moduleFunctions){
				let me =this;
				moduleFunctions.forEach(function(item){
					if(item && item.leafFlag && (item.leafFlag==1))
						item.isLeaf = '是';
					else
						item.isLeaf = '否';	
					if(item.lower){
						me.customModuleFunctions(item.lower)
					}					
				});
				
			},
			doSelectModuleFunction(moduleFunction){
				if(!this.editing)
					return;
				if(moduleFunction){
					if(moduleFunction.lower){
						//由下级元素调整状态的过程中自动调整父元素，本级元素不需要触发
						this.selectLowerModuleFunctionState(moduleFunction,1,true,false);
					}
					this.selectModuleFunctionState(moduleFunction,1,false,true);
				}
			},
			doUnSelectModuleFunction(moduleFunction){
				if(!this.editing)
					return;
				if(moduleFunction){
					if(moduleFunction.lower){
						this.selectLowerModuleFunctionState(moduleFunction,-1,true,false);
					}
					this.selectModuleFunctionState(moduleFunction,-1,false,true);
				}
			},
			selectLowerModuleFunctionState(moduleFunction,state,cascadeChildren,needCheckParentState){
				let me = this;
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
				//先选中所有子节点
				if(moduleFunction.lower){
					moduleFunction.lower.forEach(function(item){
						item.selectState = state;
						me.selectModuleFunctionState(item,state,cascadeChildren,needCheckParentState);
					});
				}
			},
			selectModuleFunctionState(moduleFunction,state,cascadeChildren,needCheckParentState){
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
					
				if(cascadeChildren==true){
					this.selectLowerModuleFunctionState(moduleFunction,state,cascadeChildren,needCheckParentState);
				}
				moduleFunction.selectState = state;
				if(needCheckParentState){
					this.selectCheckParentNode(moduleFunction,needCheckParentState);
				}
			},
			selectCheckParentNode(moduleFunction,cascadeParent){
				let me =this;
				let parentModuleFunction = this.getParentModuleFunction(moduleFunction);
				if(parentModuleFunction){
					if(this.getChildrenAllSelectedState(parentModuleFunction)==1)
						parentModuleFunction.selectState = 1;
					else if(this.getChildrenAllSelectedState(parentModuleFunction)==-1)	
						parentModuleFunction.selectState = -1;
					else
						parentModuleFunction.selectState = 0;
					if(cascadeParent)	
						me.selectCheckParentNode(parentModuleFunction,cascadeParent);
				}
			},
			//0部分选择 1 全部选择 -1全部未选
			getChildrenAllSelectedState(moduleFunction){
				let foundSelected = false;
				let foundUnSelected = false;
				let foundSomeSelected = false;
				moduleFunction.lower.forEach(function(item){
					if((item.selectState)&&(item.selectState==1))
						foundSelected = true;
					else if((item.selectState)&&(item.selectState==-1))
						foundUnSelected = true;
					else
						foundSomeSelected = true;
						
				});
				if(((foundSelected==true)&&(foundUnSelected==true))||(foundSomeSelected==true))
					return 0;
				else if(foundSelected)
					return 1;
				return -1;	
			},
			getParentModuleFunction(moduleFunction){
				let lenPerLevel=4;
				let parentModuleFunctionCode = moduleFunction.moduleFuncCode.substr(0,moduleFunction.moduleFuncCode.length-1*lenPerLevel);
				return this.moduleFunctionCodeMap.get(parentModuleFunctionCode);				
			},
			
			genTree(moduleFunctions){
				let lenPerLevel=4;
				let me = this;
				let result = [];
				let map = new Map();
				let orderedModuleFunction =  moduleFunctions.sort(me.compareModuleFunction);
				
				//let orderedModuleFunction = moduleFunctions;
				orderedModuleFunction.forEach(function(item){
					let code = item.moduleFuncCode;
					item.lower = [];
					item.selectState=-1;
					if(code.length==1*lenPerLevel)
						result.push(item);
					else{
						let parentItem = map.get(code.substr(0,code.length-1*lenPerLevel));
						if(parentItem){
							parentItem.lower.push(item);
						}
					}	
					map.set(code,item);
				});
				this.moduleFunctionCodeMap = map;
				return result;
			},
			compareModuleFunction(moduleFunction1,moduleFunction2){
				let res = 0;
				if(moduleFunction1.moduleFuncCode.length<moduleFunction2.moduleFuncCode.length)
					res = -1;
				else if(moduleFunction1.moduleFuncCode<moduleFunction2.moduleFuncCode)	
					res = -1;
				else 
					res = 1;
				return res;
			},
			levelModuleFunctions(moduleFunctions,level,higherModuleFunction){
				let me = this;
				
				moduleFunctions.forEach(function(item){
					me.moduleFunctions.push(item);
					item.higher = higherModuleFunction;
					item.level = level;
					item.opened = false;		
					if(item.lower)
						me.levelModuleFunctions(item.lower,level+1,item);		
						
				});
			},
			canOpen(moduleFunction){
				return this.hasLower(moduleFunction)&&(!moduleFunction.opened);
			},
			canClose(moduleFunction){
				return this.hasLower(moduleFunction)&&(moduleFunction.opened);
			},
			hasLower(moduleFunction){
				return moduleFunction && moduleFunction.lower && moduleFunction.lower.length && moduleFunction.lower.length>0 ;
			},
			openModuleFunction(moduleFunction){
				moduleFunction.opened = true;
				this.collectVisibleModuleFunctions();
			},
			closeModuleFunction(moduleFunction){
				moduleFunction.opened = false;
				this.collectVisibleModuleFunctions();
			}, 
			moduleFunctionVisible(moduleFunction){
				if(!moduleFunction.higher)
					return true;
				return moduleFunction.higher.opened;	
			},
			collectVisibleModuleFunction(visible,moduleFunction){
				let me = this;
				if(me.moduleFunctionVisible(moduleFunction)){
					visible.push(moduleFunction);
					if(moduleFunction.lower){
						moduleFunction.lower.forEach(function(item){
							me.collectVisibleModuleFunction(visible,item);
						});
					}
				}
			},
			collectVisibleModuleFunctions(){
				let visible = [];
				let me = this;
				me.moduleFunctions.forEach(function(item){
					me.collectVisibleModuleFunction(visible,item);
				});				
				me.visibleModuleFunctions=visible;
			},
		},
		computed:{	
			
		},		
		created(){
		}
	}
</script>

<style scoped>
	.module-function-table-root{
		
	}
	.module-function-table{
		width:100%;
        height:100%;
	}
	.code-item{
		flex-grow: 100;
	}
</style>
